import {SeoError} from './SeoError.js'

export class SeoDataRequestError extends SeoError {}
